import api from "./index";
import type { Child, ParentProfile } from "./types";

export const accountApi = api.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<{ jwt: string; refreshToken: string | null; profile: ParentProfile }, { identifier: string; password: string; rememberMe?: boolean }>({
      query: (body) => ({ url: "/account/login", method: "POST", body }),
    }),
    me: builder.query<{ profile: ParentProfile; children: Child[]; portalUrl: string }, void>({
      query: () => ({ url: "/account/me" }),
      providesTags: ["Me"],
    }),
  }),
});

export const { useLoginMutation, useMeQuery } = accountApi;
